<template>
  <section class="technical-section">
    <no-results
      :image="BASE_URL + image"
      :text="description"
      :header-text="title"
      :static-image-size="altW ? '236px' : ''"
    >
      <template #sup>
        <slot name="sup" />
      </template>
      <template #footer>
        <slot name="action" />
      </template>
    </no-results>
  </section>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import NoResults from 'components/ui/NoResults.vue'
import { useSystemStore } from 'stores/system'
import { BASE_URL } from 'src/common/config'

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    required: true,
  },
})

const { altW } = storeToRefs(useSystemStore())
</script>

<style scoped lang="scss">
.technical-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
